//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import { StyledTableCell } from './TableCell'

// "width: 1%" is needed to prevent the cell from expanding to fit the content
export const StyledTableCellWithActions = styled(StyledTableCell)`
  white-space: nowrap;
  text-align: right;
  width: 1%;
`

const TableCellWithActions = ({ children }) => {
  return (
    <StyledTableCellWithActions>
      {children}
    </StyledTableCellWithActions>
  )
}

TableCellWithActions.propTypes = {
  children: PropTypes.node,
}

export default TableCellWithActions
